<template>
  <div class="" v-if="algolia !== null">
    <ListContent
      :algolia="algolia"
    >
      <template v-slot:filters>
        <DropsFilters />
      </template>
      <template v-slot:listActionPanel>
        <ListActionPanel
        :isCheckable="true"
        >
          <template v-slot:extraButtons>
            <ExportPalletList @changeDialog="dialog = true" />
          </template>
        </ListActionPanel>
      </template>
      <template v-slot:list>
        <!-- <ais-configure
          :filters="customFilters"
        /> -->
        <ais-hits>
          <div
          v-if="items.length > 0"
          slot-scope="{ page, items}"
          >
            <ListItemCardBig
              v-for="item in items"
              :key="item.objectID"
              color="#ef476f"
              :resource="{...item, id: item.objectID}"
              @cardClicked="handleDropSelect"
            >
              <!-- {{item.units}} -->
              <DropItemCardBig :drop="item" />
            </ListItemCardBig>
          </div>
          <div v-else>
            {{ $t('drops.empty_drops') }}
          </div>
        </ais-hits>
      </template>
    </ListContent>
    <v-dialog v-model="dialog" width="270">
      <v-card>
        <v-card-title class="subheading text-center">
          {{$t('print_files.no_pallets_to_print')}}
        </v-card-title>
        <v-card-actions class="justify-center">
          <v-btn @click="dialog = false" color="#EF476F" class="white--text">{{$t('print_files.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { dropService } from '@/_services'
import { Auth } from '@/_services/amplify.service'

import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ListContent from '@/components/wrld/generic/ListContent'
import ListActionPanel from '@/components/wrld/generic/ListActionPanel'
import DropsFilters from '@/components/drops/DropsFilters'
import DropItemCardBig from '@/components/drops/DropItemCardBig'
import ExportPalletList from '@/components/drops/ExportPalletList'

export default {
  name: 'DropOverviewContent',
  components: {
    ListItemCardBig,
    ListContent,
    ListActionPanel,
    DropsFilters,
    DropItemCardBig,
    ExportPalletList
  },
  props: {},
  data () {
    return {
      algolia: null,
      dialog: false
    }
  },
  created () {
    Auth.currentSession().then((session) => {
      this.algolia = { indexName: 'prod_drops_v2',
        urlSync: true,
        searchParameters: {
          filters: `viewableBy:${session.getIdToken().payload.org}`
        } }
    })
  },
  computed: {
    ...mapGetters([
      'getCheckedOnPageCount',
      'getSelectedResource',
      'getSelectedResourceID',
      'getSelectedCustomFilters',
      'getResourceOverviewList'
    ]),
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    }
  },
  methods: {
    ...mapActions({
      updateResource: 'updateResource',
      setSelectedDropDetails: 'setSelectedDropDetails',
      selectUnit: 'selectUnit'
    }),
    handleDropSelect (dropID) {
      this.selectUnit({ unit: null })
      // this.setSelectedDropDetails({ drop: this.getSelectedResource })
      if (this.getSelectedResourceID.objectID !== null) {
        dropService.getDropOverview({ id: dropID }).then((response) => {
          this.updateResource({ resource: { ...response.data.getDrop.drop, id: dropID, units:[] } })
          this.setSelectedDropDetails({ drop: response.data.getDrop.drop })
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
